import { browserHelpers } from '@approvalmax/utils';
import { SimplePageLayout } from 'modules/page';
import { FC, memo } from 'react';
import { useSelector } from 'react-redux';

import SignupLoginModule from '../../containers/SignupLoginModule/SignupLoginModule';
import TwoFaLoginModule from '../../containers/TwoFaLoginModule/TwoFaLoginModule';
import { PageActiveModule } from '../../reducers/page/moduleReducer';
import { getDocumentTitle, getModule } from '../../selectors/pageSelectors';

const LoginPageContent: FC = () => {
    const documentTitle = useSelector(getDocumentTitle);
    const module = useSelector(getModule);

    let content = null;
    let showMobileAppButtons = false;
    let activeModule: PageActiveModule.LoginModule | undefined;

    switch (module.type) {
        case PageActiveModule.LoginModule:
            content = (
                <SignupLoginModule
                    activeModule={PageActiveModule.LoginModule}
                    hideModuleSwitcher={browserHelpers.isMobile()}
                />
            );
            showMobileAppButtons = true;
            activeModule = PageActiveModule.LoginModule;

            break;

        case PageActiveModule.TwoFaLoginModuleData:
            content = (
                <TwoFaLoginModule
                    isTrustThisDeviceEnabled
                    isTFAAlternativeEmailEnabled={module.isTFAAlternativeEmailEnabled}
                    isTFABackupCodesEnabled={module.isTFABackupCodesEnabled}
                />
            );
            break;
    }

    return (
        <SimplePageLayout
            documentTitle={documentTitle}
            showMobileAppButtons={showMobileAppButtons}
            activeModule={activeModule}
        >
            {content}
        </SimplePageLayout>
    );
};

export default memo(LoginPageContent);
